import { blobticService } from '../../Commun/services/blobticService';

export interface FuelCard {
    id: number;
    uid?: string;
    cardNumber: string;
    vehicleId?: number;
    driverId?: number;
    globalCost: number;
    pricePerLiter: number;
    vehicleRegistration?: string;
    driverName?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface FuelCardDto {
    FCD_IDF: number;
    FCD_UIDF: string;
    FCD_NUMBER: string;
    VEH_IDF?: number;
    DRV_IDF?: number;
    FCD_COUT_GLOBAL?: number;
    FCD_PRIX_LITRE?: number;
    VEH_REGISTRATION?: string;
    DRV_NAME?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: FuelCardDto): FuelCard => ({
    id: dto.FCD_IDF,
    uid: dto.FCD_UIDF,
    cardNumber: dto.FCD_NUMBER,
    vehicleId: dto.VEH_IDF,
    driverId: dto.DRV_IDF,
    globalCost: dto.FCD_COUT_GLOBAL || 0,
    pricePerLiter: dto.FCD_PRIX_LITRE || 130,
    vehicleRegistration: dto.VEH_REGISTRATION,
    driverName: dto.DRV_NAME,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const fuelCardsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_fuel_card,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<FuelCard>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_fuel_card,Insert',
            FCD_NUMBER: data.cardNumber,
            VEH_IDF: data.vehicleId,
            DRV_IDF: data.driverId,
            FCD_COUT_GLOBAL: data.globalCost || 0,
            FCD_PRIX_LITRE: data.pricePerLiter || 130
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<FuelCard>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_fuel_card,Update',
            FCD_IDF: id,
            FCD_NUMBER: data.cardNumber,
            VEH_IDF: data.vehicleId,
            DRV_IDF: data.driverId,
            FCD_COUT_GLOBAL: data.globalCost,
            FCD_PRIX_LITRE: data.pricePerLiter
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_fuel_card,Delete', FCD_IDF: id }
        });
        return response;
    }
};
